import { BaseType } from '../../../models/base/base-type';
import { FiduciaryPowerOfAttorneyTypeEnum } from '../enums/fiduciary-power-of-attorney-type.enum';

export class FiduciaryPowerOfAttorneyType extends BaseType {
  public declare id: FiduciaryPowerOfAttorneyTypeEnum;
}
